import routerOptions0 from "/builds/racent/frontend/website_nicsrs/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}